export var Channel;
(function (Channel) {
    Channel["STAR"] = "*";
    Channel["X"] = "X";
    Channel["Y"] = "Y";
    Channel["X2"] = "X2";
    Channel["Y2"] = "Y2";
    Channel["ROW"] = "ROW";
    Channel["COLUMN"] = "COLUMN";
    Channel["VALUE"] = "VALUE";
    Channel["SERIES"] = "SERIES";
    Channel["COLOR"] = "COLOR";
    Channel["SIZE"] = "SIZE";
    Channel["TEXT"] = "TEXT";
    Channel["DETAIL"] = "DETAIL";
    Channel["TOOLTIP"] = "TOOLTIP";
    Channel["SHAPE"] = "SHAPE";
    Channel["ANGLE"] = "ANGLE";
    Channel["PATH"] = "PATH";
})(Channel || (Channel = {}));
